<div class="slider-row" [class.slider-disabled]="disabled">
  <span class="slider-label">{{ label }}:</span>
  <div class="slider-track-wrapper"
       [style.pointer-events]="disabled ? 'none' : 'auto'"
       (mousedown)="onTrackMouseDown($event)"
       (touchstart)="onTrackTouchStart($event)">
    <div #track class="slider-track">
      <div class="track-bar" [style.background]="trackGradient"></div>
      <span *ngFor="let val of values; let i = index; trackBy: trackByIndex"
            class="thumb-label"
            [style.left]="getThumbLeft(val)">
        {{ val }}
      </span>
      <span *ngFor="let val of values; let i = index; trackBy: trackByIndex"
            class="thumb-label-float"
            [class.visible]="getNearPosition(i)"
            [class.above]="getNearPosition(i) === 'above'"
            [class.below]="getNearPosition(i) === 'below'"
            [style.left]="getThumbLeft(val)">
        {{ val }}
      </span>
    </div>
  </div>
</div>
